import React from 'react';
import { Field, FieldArray } from 'formik';
import Link from '@nib-components/link';
import { Margin } from '@nib/layout';
import Divider from '@nib-components/divider';
import Heading from '@nib-components/heading';
import Copy from '@nib-components/copy';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS, MIN_ADULT_DEPENDANT_AGE, FUNNELS, MAX_ADULT_DEPENDANT_AGE_31 } from '../../util/constants';
import { DependantsGroupRadio, NestedFormFields, FirstName, LastName, Sex, DateOfBirth, SecondaryButton, TransferringFundsGroup } from '../..';
import { formatDecimal } from '../../util/format-decimal';
import { getGroupEventHandlerProps } from '../../util/propTypes';
import { hasAdultDependants, generateNameMask } from '../../util/validationHelpers';
import DependantResidencyStatusGroup from '../dependant-residency-status';
import { Box } from '@nib/layout';
import StudentDependant from '../student-dependant';
import { Help } from '@nib-components/form-control';
import { format } from 'date-fns';
import { Selected } from '@nib/phi-constants';
import CommonDate from '../common-date';
import { getAge } from '../../util/getAge';
import { StandardInfoBox } from '../info-box';
const CURRENT_PROVIDER_LABEL = {
  ARHI: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL_ARHI,
  GU: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL,
  IMAN: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL,
  IWHI: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL,
  ISHI: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL,
  IAP: LABELS.PARTNER_TRANSFERRING_FUNDS_PROVIDER_LABEL
};
const CUSTOM_LABELS = {
  STUDENT_GRADUATION_DATE: LABELS.STUDENT_GRADUATION_DATE
};
class DependantsGroup extends React.Component {
  constructor(props) {
    super(props);
    this.showAdultDependantsModal = e => {
      this.setState({
        showDependantModal: !this.state.showDependantModal
      });
    };
    this.state = {
      previouslyAddedAdultDependants: null,
      showDependantModal: false
    };
  }
  removeChild(arrayHelpers, index, externalEventHandler) {
    const {
      values
    } = this.props;
    // Don't allow removal of first item.
    if (values && values.dependants.length !== 1) {
      const dependantRemoved = arrayHelpers.remove(index);
      if (externalEventHandler) {
        externalEventHandler({
          dependantRemoved,
          index
        });
      }
    }
  }
  addChild(arrayHelpers, externalEventHandler) {
    arrayHelpers.push({
      childFirstName: '',
      childLastName: '',
      childSexOf: '',
      childDateOfBirth: '',
      childDateOfBirthDay: '',
      childDateOfBirthMonth: '',
      childDateOfBirthYear: '',
      childTransferringFunds: '',
      'childTransferringFunds--currentProvider': '',
      'childTransferringFunds--memberNumber': '',
      isStudentDependant: null,
      ...(this.props.includeResidencyStatus && {
        'childResidencyStatus--medicareCardType': '',
        'childResidencyStatus--residencyStatus': '',
        'childResidencyStatus--citizenshipCountry': '',
        'childResidencyStatus--noCardResidencyStatus': ''
      })
    });
    // TODO: PHISL-7362 refactor: This looks like a hack to get around the fact that the external event handler is not being called
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    externalEventHandler && externalEventHandler();
  }
  static getDerivedStateFromProps(props) {
    var _a;
    const {
      minAdultDependantAge = MIN_ADULT_DEPENDANT_AGE,
      maxAdultDependantAge = MAX_ADULT_DEPENDANT_AGE_31
    } = props;
    const newState = {};
    const hasAddedAdultDependants = hasAdultDependants((_a = props.values) === null || _a === void 0 ? void 0 : _a.dependants, minAdultDependantAge, maxAdultDependantAge);
    newState.hasAddedAdultDependants = hasAddedAdultDependants;
    if (hasAddedAdultDependants != null) {
      newState.previouslyAddedAdultDependants = hasAddedAdultDependants;
    }
    return newState;
  }
  render() {
    const {
      funnel = FUNNELS.ARHI,
      id = 'dependantsGroup',
      name = 'dependantsGroup',
      excludeDependantsGroupRadio = false,
      lastNameMaxLength = 24,
      sexHelp = '',
      maxDependants = 12,
      groupOnBlurHandlers = {},
      groupOnChangeHandlers = {},
      showAdultDependantsInfoBox = false,
      values,
      nameMaxLength,
      dependantsLabel,
      dependantsHelp,
      formMode,
      policyPrice,
      currentProviderOptions,
      currentProviderSuggestions,
      policyHolderHasPreviousFund,
      partnerHasPreviousFund,
      showDependantTransferringFunds,
      includeResidencyStatus,
      residencyStatusHelpText,
      hasResidencyMismatchAtIndex,
      AdultDependantModal,
      studentDependantMaxAge,
      required
    } = this.props;
    const showSubfields = (values === null || values === void 0 ? void 0 : values[id]) === 'yes' || excludeDependantsGroupRadio;
    const eventHandlers = {
      groupOnBlurHandlers,
      groupOnChangeHandlers
    };
    return React.createElement("div", null, React.createElement(FieldArray, {
      name: "dependants",
      render: arrayHelpers => {
        return React.createElement("div", null, !excludeDependantsGroupRadio && React.createElement(Field, {
          name: name,
          id: id,
          component: DependantsGroupRadio,
          label: dependantsLabel,
          help: dependantsHelp,
          ...getGroupEventHandlerProps({
            ...eventHandlers,
            id
          })
        }), React.createElement(NestedFormFields, {
          expanded: showSubfields,
          id: `${name}--nestedFormFields`
        }, (values === null || values === void 0 ? void 0 : values.dependants.length) === 0 && React.createElement(SecondaryButton, {
          id: "child-add",
          type: "button",
          onClick: () => this.addChild(arrayHelpers)
        }, "Add Dependant"), values === null || values === void 0 ? void 0 : values.dependants.map((member, index) => {
          const hasDependantResidencyMismatch = index === hasResidencyMismatchAtIndex;
          const isLastDepedant = values.dependants.length === index + 1;
          const dependantDOB = member.childDateOfBirth;
          // student dependant check
          const currentDate = format(new Date(), 'yyyy-MM-dd');
          const dependantAge = getAge(dependantDOB, currentDate);
          const isDependantAgeOverMinAge = dependantAge >= MIN_ADULT_DEPENDANT_AGE;
          const isDependantAgeUnderMaxAge = !!studentDependantMaxAge && dependantAge < studentDependantMaxAge;
          const enableStudentDependants = isDependantAgeOverMinAge && isDependantAgeUnderMaxAge;
          const isStudentDependant = member.isStudentDependant === Selected.yes;
          return React.createElement(React.Fragment, {
            key: index
          }, React.createElement(Heading, {
            size: 3,
            component: "h3"
          }, "Dependant's details"), React.createElement(Field, {
            required: required,
            name: `dependants.${index}.childFirstName`,
            id: `dependants.${index}.childFirstName`,
            maxLength: nameMaxLength,
            mask: generateNameMask(nameMaxLength),
            component: FirstName,
            ...getGroupEventHandlerProps({
              ...eventHandlers,
              id: 'childFirstName'
            })
          }), React.createElement(Field, {
            required: required,
            name: `dependants.${index}.childLastName`,
            id: `dependants.${index}.childLastName`,
            maxLength: lastNameMaxLength,
            mask: generateNameMask(lastNameMaxLength),
            component: LastName,
            ...getGroupEventHandlerProps({
              ...eventHandlers,
              id: 'childLastName'
            })
          }), React.createElement(Field, {
            required: required,
            name: `dependants.${index}.childSexOf`,
            id: `dependants.${index}.childSexOf`,
            component: Sex,
            help: sexHelp,
            ...getGroupEventHandlerProps({
              ...eventHandlers,
              id: 'childSexOf'
            })
          }), React.createElement(Field, {
            required: required,
            name: `dependants.${index}.childDateOfBirth`,
            id: `dependants.${index}.childDateOfBirth`,
            component: DateOfBirth,
            onDateBlur: groupOnBlurHandlers.childDateOfBirth,
            formMode: formMode
          }), enableStudentDependants && AdultDependantModal && React.createElement(Field, {
            required: required,
            name: `dependants.${index}.isStudentDependant`,
            id: `dependants.${index}.isStudentDependant`,
            component: StudentDependant,
            help: React.createElement(Help, null, React.createElement(AdultDependantModal, {
              onClose: this.showAdultDependantsModal,
              visible: this.state.showDependantModal
            }), "A", React.createElement(Link, {
              onClick: e => {
                this.showAdultDependantsModal(e);
              },
              target: "_blank",
              color: 'dark'
            }, ' ', "student dependant", ' '), "is a full-time student, single (not married or in a defacto relationship) and aged between 21 and ", studentDependantMaxAge || MAX_ADULT_DEPENDANT_AGE_31, "."),
            ...getGroupEventHandlerProps({
              ...eventHandlers,
              id: 'isStudentDependant'
            })
          }), showAdultDependantsInfoBox && (this.state.hasAddedAdultDependants === index || index === this.state.previouslyAddedAdultDependants) && React.createElement(StandardInfoBox, {
            role: "status"
          }, React.createElement(Copy, null, "Your price has been updated to reflect your changed dependant details. ", React.createElement("b", null, "New price $", formatDecimal(policyPrice, {
            places: 2,
            separator: ','
          }), "*"), ".")), enableStudentDependants && isStudentDependant && React.createElement(Field, {
            optional: true,
            name: `dependants.${index}.graduationDate`,
            id: `dependants.${index}.graduationDate`,
            component: CommonDate,
            onDateBlur: groupOnBlurHandlers.graduationDate,
            formMode: formMode,
            label: CUSTOM_LABELS.STUDENT_GRADUATION_DATE
          }), includeResidencyStatus && React.createElement(DependantResidencyStatusGroup, {
            values: values,
            name: `dependants.${index}.childResidencyStatus`,
            id: `dependants.${index}.childResidencyStatus`,
            groupOnBlurHandlers: groupOnBlurHandlers.childResidencyStatus,
            groupOnChangeHandlers: groupOnChangeHandlers.childResidencyStatus,
            hasDependantResidencyMismatch: hasDependantResidencyMismatch,
            residencyStatusHelpText: residencyStatusHelpText
          }), showDependantTransferringFunds && !hasDependantResidencyMismatch && React.createElement(TransferringFundsGroup, {
            required: required,
            isDependant: true,
            values: values,
            name: `dependants.${index}.childTransferringFunds`,
            id: `dependants.${index}.childTransferringFunds`,
            label: LABELS.CHILD_TRANSFERRING_FUNDS_RADIO,
            subHeading: LABELS.PARTNER_TRANSFERRING_FUNDS_SUB_HEADING,
            currentProviderHelp: "",
            currentProviderLabel: CURRENT_PROVIDER_LABEL[funnel] || CURRENT_PROVIDER_LABEL.ARHI,
            memberNumberLabel: LABELS.PARTNER_TRANSFERRING_FUNDS_MEMBER_NUMBER_LABEL,
            currentProviderOptions: currentProviderOptions,
            currentProviderSuggestions: currentProviderSuggestions,
            groupOnBlurHandlers: groupOnBlurHandlers.childTransferringFunds,
            groupOnChangeHandlers: groupOnChangeHandlers.childTransferringFunds,
            policyHolderHasPreviousFund: policyHolderHasPreviousFund,
            partnerHasPreviousFund: partnerHasPreviousFund
          }), values.dependants.length !== 1 && React.createElement(Box, null, React.createElement(Link, {
            id: "child-remove",
            component: "button",
            type: "button",
            onClick: () => this.removeChild(arrayHelpers, index, groupOnChangeHandlers.onRemove)
          }, "Remove dependant")), !isLastDepedant && React.createElement(Margin, {
            vertical: 4
          }, React.createElement(Divider, null)), values.dependants.length < maxDependants && isLastDepedant && !hasDependantResidencyMismatch && React.createElement(React.Fragment, null, React.createElement(Margin, {
            vertical: 4
          }, React.createElement(Divider, null)), React.createElement(SecondaryButton, {
            id: "child-add",
            type: "button",
            onClick: () => this.addChild(arrayHelpers, groupOnChangeHandlers === null || groupOnChangeHandlers === void 0 ? void 0 : groupOnChangeHandlers.onAdd)
          }, "Add another dependant")));
        })));
      }
    }));
  }
}
const DependantsGroupWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(DependantsGroup, {
  ...props
}));
export default DependantsGroupWithFunnel;